import SecurityOwnership from './SecurityOwnership';
export { SecurityOwnership };
export default SecurityOwnership;
